// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"8daa044f","804":"8f8e10ae","944":"c0563388"}[chunkId] + ".js";
};